export * from "./adapter-scheduled-work-orders-completed-summary.interface";
